import { createApiSlice } from "@common";
import { CRUD_PURCHASE_TIMELINE } from "@routes";

const apiConfig = [
  {
    name: "addPurchaseTimeline",
    method: "post",
    url: CRUD_PURCHASE_TIMELINE,
    stateKey: "message",
  },
  {
    name: "getPurchaseTimeline",
    method: "get",
    url: CRUD_PURCHASE_TIMELINE,
    stateKey: "data",
  },
  {
    name: "updatePurchaseTimeline",
    method: "put",
    url: CRUD_PURCHASE_TIMELINE,
    stateKey: "message",
  },
  {
    name: "deletePurchaseTimeline",
    method: "delete",
    url: CRUD_PURCHASE_TIMELINE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"purchaseTimeline",
 apiConfig, 
 customReducers);
const purchaseTimelineSlice = slice;

export default purchaseTimelineSlice.reducer;

export const {
  addPurchaseTimeline,
  getPurchaseTimeline,
  updatePurchaseTimeline,
  deletePurchaseTimeline,
} = thunks;

export const { rowSelect } = actions;
